import styled from "styled-components";
import { media } from "../../../../../layouts/utils";
import { colorBrandPrimary } from "src/global.style";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  filter: ${({ blur }) => (blur ? "blur(2px)" : "")};
  user-select: ${({ blur }) => (blur ? "none" : "auto")};
  .botoesCupons {
    display: flex;
    gap: 2rem;

    ${media.phone`
			gap: 1rem;
    `}
	}
  ${media.phone`
			gap: 2rem;
  `}
`;
export const Terms = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 1.25rem;
  font-size: 1rem;
  font-weight: 500;
  color: ${colorBrandPrimary.blue};
  
  @media (min-width: 768px) and (max-width: 900px){
    margin-left: 20px;
  }
  ${media.phone`
    gap: 2rem;
    align-items: center;
  `}

  p {
    ${media.phone`
      margin-left: 5px;
    `}
  }

  b {
    font-weight: 600;
    text-decoration: underline;
    user-select: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
      filter: brightness(1.2);
    }
  }

  ${media.phone`
    color: ${({ color }) => (color ? `${colorBrandPrimary.blue}` : "#230C87")};
	  font-size: 1rem;
    padding: 32px 14px 0 0px
 `}
`;

export const Link = styled.a`
	text-decoration: none;
	${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
`;
export const ModalHeader = styled.div`
	display: flex;
	align-content: center;
	justify-content: flex-end;
	width: 100%;
	height: 40px;
`;
export const CloseButton = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    filter: brightness(2);
  }
`;

export const Line = styled.p`
	margin-bottom: 19px;
	font-weight: 400;

	.bold {
		font-weight: bold;
	}
	.italic {
		font-style: italic;
	}
	.underline {
		text-decoration: underline;
	}
	.strike {
		text-decoration: line-through;
	}
`;
export const TextBlock = styled.span`
	&.underline {
		text-decoration: underline;
	}
	&.bold {
		font-weight: bold;
	}
	&.italic {
		font-style: italic;
	}
`;
